import React, { useEffect, useState } from "react";

export default function About({user}) {
    return(
        <button> </button>
    );
}